<template>
  <div v-if="products">
    <div v-if="type == 'individual'">
      <p>
        Choose the subscriptions you need:
      </p>
      <p v-if="mathsAvailable">
        <strong>
          Maths - £10 per year
        </strong> 
        <br>
        Access more than 300 maths games and curriculum-aligned activities. 
        Practise key skills, receive instant animated feedback and track your 
        progress.
      </p>
      <p>
        <strong>
          Spelling - £10 per year
        </strong>
        <br>
        Access all spelling games and activities, practise National Curriculum 
        spelling rules and create personalised word lists.
      </p>
      <p v-if="mathsAvailable">
        <strong>
          Maths worksheets - £10 per year
        </strong>
        <br>
        Access printable worksheets and assessments, organised by year group 
        and curriculum topic.
      </p>
      <p v-if="mathsAvailable">
        <strong>All three subcriptions - £25 per year</strong>
      </p>
      <p>
        All prices include VAT.
      </p>
    </div>
    <div v-else-if="type == 'school'">
      <p>
        Create individual logins for every child in your class. Set differentiated 
        tasks and monitor pupils' scores and progress.
      </p>
      <p v-if="mathsAvailable">
        <strong>
          Maths - £30 + VAT per class, per year
        </strong>
        <br>
        Access all maths games, interactive questions and teaching tools, plus 
        printable maths worksheets.
      </p>
      <p>
        <strong>
          Spelling - £30 + VAT per class, per year
        </strong>
        <br>
        Create differentiated word lists and give pupils personalised spelling 
        practice with spoken words, example sentences and immediate feedback.
      </p>
      <p v-if="mathsAvailable">
        <strong>
          Maths and spelling together - £50 + VAT per class, per year
        </strong>
        <br>
        Students and teachers can access all resources with a single username and 
        password and can move between maths and spelling tasks without logging out.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { SfAccountType } from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";
import {
  storeProducts,
  discountedIndividualCost,
  discountedSchoolCost,
} from "@/state/productsState";
import { isMathsAvailable } from "@/state/appState";

export default defineComponent({
  components: {},
  props: {
    type: { type: String as PropType<SfAccountType>, required: true },
  },
  data() {
    return {};
  },
  computed: {
    products() {
      return storeProducts.value;
    },
    discoutedIndividualCost() {
      return discountedIndividualCost.value;
    },
    discountedSchoolCost() {
      return discountedSchoolCost.value;
    },
    mathsAvailable() {
      return isMathsAvailable(this.type, 'store');
    }
  },
});
</script>
